import React from 'react';

const App: React.FC = () => {
  return (
    <div>test</div>
  );
}

export default App;
